<template>
  <div>
    <br/>
    Charity address: {{ charityAddress }}<br/>
    Charity balance: {{ charityBalance }}<br/>
    <br/>
    Artist address: {{ artistAddress }}<br/>
    Artist balance: {{ artistBalance }}<br/>
    <br/>
    Num shipments: {{ numShipments }}<br/>
    Num charities: {{ numCharities }}<br/>
    <br/>
    <br/>
    <br/>

    <b-form class="on-the-left" @submit="onCharitySubmit">
      <b-form-group id="charityNameGroup"
          label="Charity Name:"
          label-for="charityName">
        <b-form-input id="charityName"
              required
              type="text"
              placeholder="Blah Ltd"
              v-model="charityName">
        </b-form-input>
      </b-form-group>

      <b-form-group id="charityAddressGroup"
          label="Charity Address:"
          label-for="charityAddress">
        <b-form-input id="charityAddress"
              required
              type="text"
              placeholder="0x1234"
              v-model="charityAddress">
        </b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary">Submit</b-button>
    </b-form>
    <br/>
    <b-button @click="withdrawArtistFunds">Withdraw artist</b-button>
    <br/>
    <br/>
    <b-button @click="withdrawCharityFunds">Withdraw charity</b-button>

    <b-form class="on-the-left" @submit="unlock">
        <b-form-input id="unlockAddress"
              required
              type="text"
              placeholder="0xunlock"
              v-model="unlockAddress"/>
      <b-button type="submit" variant="primary">Unlock</b-button>
    </b-form>

  </div>
</template>

<script>
import Web3 from 'web3'
import NavBar from '@/components/NavBar'

export default {
  name: 'buy-art',
  components: {
    'nav-bar': NavBar
  },
  data () {
    return {
      web3: null,
      web3Provider: null,
      contracts: {},
      charityName: null,
      charityBalance: 0,
      charityAddress: null,
      numCharities: 0,
      artistAddress: null,
      artistBalance: 0,
      unlockAddress: null,
      numShipments: 0
    }
  },
  mounted () {
    this.getProvider()
  },
  methods: {
    onCharitySubmit (evt) {
      evt.preventDefault();
      this.newCharity();
    },
    unlock() {
      web3.eth.getAccounts((error, accounts) => {
        if (error) {
          console.log(error)
          return
        }
        this.account = accounts[0]
        this.contracts.Art30.deployed().then((instance) => {
          var art30Instance = instance
          return art30Instance.setCollectorFundsLocked(this.unlockAddress, false, {from: this.account})
        }).then((result) => {
          console.log(result)
        }).catch((err) => {
          console.log(err.message)
        })
      })
    },
    withdrawArtistFunds() {
      web3.eth.getAccounts((error, accounts) => {
        if (error) {
          console.log(error)
          return
        }
        this.account = accounts[0]
        this.contracts.Art30.deployed().then((instance) => {
          var art30Instance = instance
          return art30Instance.withdrawArtistFunds({from: this.account})
        }).then((result) => {
          console.log(result)
        }).catch((err) => {
          console.log(err.message)
        })
      })
    },
    withdrawCharityFunds() {
      web3.eth.getAccounts((error, accounts) => {
        if (error) {
          console.log(error)
          return
        }
        this.account = accounts[0]
        this.contracts.Art30.deployed().then((instance) => {
          var art30Instance = instance
          return art30Instance.withdrawCharityFunds({from: this.account})
        }).then((result) => {
          console.log(result)
        }).catch((err) => {
          console.log(err.message)
        })
      })
    },
    newCharity() {
      web3.eth.getAccounts((error, accounts) => {
        if (error) {
          console.log(error)
          return
        }
        this.contracts.Art30.deployed().then((instance) => {
          var art30Instance = instance
          this.account = accounts[0]
          return art30Instance.newCharity(this.charityName, this.charityAddress, {from: this.account})
        }).then((result) => {
          console.log(result)
        }).catch((err) => {
          console.log(err.message)
        })
      })
    },
    getProvider () {
      // Checking if Web3 has been injected by the browser (Mist/MetaMask)
      if (typeof web3 !== 'undefined') {
        // Use Mist/MetaMask's provider
        this.web3Provider = web3.currentProvider
        web3 = new Web3(this.web3Provider)
      } else {
        // fallback - use your fallback strategy (local node / hosted node + in-dapp id mgmt / fail)
        this.web3Provider = new Web3.providers.HttpProvider('http://localhost:8545')
        web3 = new Web3(this.web3Provider)
      }
      this.getContract()
    },
    getContract () {
      var Art30Artifact = require('../../build/contracts/Art30.json')
      this.contracts.Art30 = this.$TruffleContract(Art30Artifact)
      this.contracts.Art30.setProvider(this.web3Provider)
      this.networkCheck()
      this.getAccount()
      this.getConractData()
    },
    networkCheck () {
      web3.version.getNetwork((err, netId) => {
        if (err) {
          console.log(err)
          return
        }
        switch (netId) {
          case '1':
            console.log('This is mainnet')
            break
          case '2':
            console.log('This is the deprecated Morden test network.')
            break
          case '3':
            console.log('This is the ropsten test network.')
            break
          default:
            console.log('This is an unknown network.')
        }
      })
    },
    getConractData() {
      var art30Instance
      this.contracts.Art30.deployed().then((instance) => {
        art30Instance = instance
        return art30Instance.artistBalance.call()
      }).then((result) => {
        this.artistBalance = result.valueOf()
        return art30Instance.artist.call()
      }).then((result) => {
        this.artistAddress = result.valueOf()
        return art30Instance.getNumCharities()
      }).then((result) => {
        this.numCharities = result.valueOf()
        return art30Instance.charityList.call(this.numCharities - 1)
      }).then((result) => {
        this.charityAddress = result.valueOf()
        return art30Instance.getCharityBalance(this.numCharities - 1)
      }).then((result) => {
        this.charityBalance = result.valueOf()
        return art30Instance.getNumShipments()
      }).then((result) => {
        this.numShipments = result.valueOf()
      }).catch((err) => {
        console.log(err.message)
      })
    },
    getAccount() {
      web3.eth.getAccounts((error, accounts) => {
        if (error) {
          console.log(error)
          return
        }
        if (accounts.length != 0)
        {
          this.account = accounts[0]
          console.log(this.account)
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Admin.vue